import { Component, input, output, signal, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-floating-feedback-panel',
  templateUrl: './floating-feedback-panel.component.html',
  styleUrls: ['./floating-feedback-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingFeedbackPanelComponent {
  // Inputs
  public readonly feedbackSubmitted = input<boolean>(false);
  public readonly feedbackChoice = input<'helpful' | 'not_helpful' | null>(null);
  public readonly feedbackComment = input<string>('');
  public readonly feedbackError = input<string | null>(null);
  public readonly isSubmittingFeedback = input<boolean>(false);

  // Outputs
  public readonly feedbackClicked = output<{ helpful: boolean; event?: MouseEvent }>();
  public readonly feedbackCommentChanged = output<string>();
  public readonly feedbackSubmit = output<MouseEvent | undefined>();
  public readonly closed = output<void>();

  public onFeedbackClick(helpful: boolean, event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.feedbackClicked.emit({ helpful, event });
  }

  public onFeedbackCommentChange(comment: string): void {
    this.feedbackCommentChanged.emit(comment);
  }

  public onSubmitFeedback(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.feedbackSubmit.emit(event);
  }

  public onClose(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.closed.emit();
  }
}
